import { actions as fileActions } from "components/fileViewers/logic/actions";
import { advTypesSelector } from "components/global/logic/actions";
import { setUserInfo } from "components/global/logic/sagas";
import { currentUserSelector } from "components/login/logic/actions";
import { getPreferences, transformUserForForm } from "components/settings/user/common";
import {createError, handleServerErrors} from "core/exceptions";
import { createSagasForBasicCall } from "core/sagas";
import { assertArray } from "core/validation";
import * as log from "loglevel";
import { toast } from "react-toastify";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { API_URL } from "services";
import UserService from "services/userService";
import envconfig from "../../../../../envconfig";
import { actions, loadedUserSelector } from "./actions";

export function* loadUser({ payload }) {
    try {
        const usersData = yield call(UserService.getUserById, payload);
        const advTypes = yield select(advTypesSelector);
        const currentUser = yield select(currentUserSelector);
        const user = transformUserForForm(usersData, advTypes, currentUser);
        yield put(actions.LOAD_USER.success({ user }));
    } catch (e) {
        log.error(e);
        yield put(actions.LOAD_USER.failed(null, createError(e)));
    }
}

export function payloadToDto(payload, user) {
    const advertisementTypes = assertArray(payload.advertisementTypes)
        ? payload.advertisementTypes.map((a) => a.id).join(",")
        : null;
    const preferences = {
        ...getPreferences(user),
        avatarColor: payload.avatarColor,
        avatarText: payload.avatarText,
    };

    return {
        id: payload.id,
        title: payload.title,
        firstName: payload.firstName,
        lastName: payload.lastName,
        phone: payload.phone,
        email: payload.email,
        advertisementTypes,
        preferences: JSON.stringify(preferences),
        username: payload.username,
        active: payload.active,
        password: payload.newPassword,
        passwordConfirmation: payload.newPasswordConfirmation,
        roleId: payload.role ? payload.role.value : null,
        ssoEnabled: payload.ssoEnabled ? payload.ssoEnabled : null,
    };
}
export function* saveUser({ payload }) {
    try {
        const currentUser = yield select(currentUserSelector);
        const loadedUser = yield select(loadedUserSelector);
        const form = payloadToDto(payload, loadedUser);
        const userData = yield call(UserService.save, form);

        const advTypes = yield select(advTypesSelector);
        const user = transformUserForForm(userData, advTypes, currentUser);
        yield put(actions.SAVE_USER.success({ user }));

        const messages = "User was successfully saved";
        toast.success(messages);
        const isCurrentUser = loadedUser && loadedUser.id === currentUser.id;

        if (isCurrentUser) {
            yield call(setUserInfo, userData);
        }
    } catch (e) {
        log.error(e);
        const error = createError(e);
        handleServerErrors(e, () => {
            const message = error.data?.error;
            if (message) {
                toast.error(message);
            }
        });
        yield put(actions.SAVE_USER.failed(null, error));
    }
}

export function* changePassword({ payload }) {
    try {
        yield call(UserService.changePassword, payload);
        yield put(actions.CHANGE_PASSWORD.success());
        const messages = "Password was updated successfully";
        toast.success(messages);
    } catch (e) {
        const error = createError(e);
        handleServerErrors(e, () => {
            const messages = error.data?.error;
            if (messages) {
                toast.error(messages);
            }
        });
        yield put(actions.CHANGE_PASSWORD.failed(e));
    }
}

export function* uploadSign({ payload }) {
    const { userId, file } = payload;
    const url = envconfig.api + API_URL.user(`${userId}/signature`);

    try {
        yield put(
            fileActions.UPLOAD_BATCH_ASSETS.send({
                files: [file],
                url,
            })
        );
    } catch (error) {
        log.error(error);
    }
}
export default [
    ...createSagasForBasicCall(actions),
    takeLatest(actions.LOAD_USER.sendType, loadUser),
    takeLatest(actions.SAVE_USER.sendType, saveUser),
    takeLatest(actions.CHANGE_PASSWORD.sendType, changePassword),
    takeLatest(actions.UPLOAD_SIGN.sendType, uploadSign),
];
